import type { SVGProps } from 'react';
const SvgVerticalSlider2StreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Vertical Slider 2 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M3.304 7.929a1.982 1.982 0 1 0 0-3.965 1.982 1.982 0 0 0 0 3.965M3.304 7.929v9.25M3.304 1.321v2.643M15.196 7.929a1.982 1.982 0 1 0 0-3.965 1.982 1.982 0 0 0 0 3.965M15.196 3.964V1.321M15.196 17.179v-9.25M9.25 11.232a1.982 1.982 0 1 0 0-3.964 1.982 1.982 0 0 0 0 3.964M9.25 1.321v5.947M9.25 11.232v5.947" />
    </g>
  </svg>
);
export default SvgVerticalSlider2StreamlineCore;
